import React, { Component } from 'react'
import Dropdown from '@/components/Dropdown/Dropdown';
import Input from '../Input/index';
import '../../assets/styles/components/instrument/place-order-option.scss'
import { connect } from 'react-redux';
import { formatFunctions, utilsFunction } from '@/helpers/functions';
import { dataType } from '@/constants/data-type';
import { INDEX_KEY } from '@/constants/keys.code';
import { ORDER_TYPE, STOP_TYPE_TYPE } from '@/constants/app';
import classnames from 'classnames';
import { iTradeEnv } from '@/configurations/app-configs/iTrade.env';
import { openPrePostDialog } from '@/actions/app/dialog.action'
import descriptionIcon from '@/assets/images/icons/icon_description.png';
import DatePicker  from '@/components/DatePicker/DatePicker';
import moment from 'moment'

const DESELECT_OPTION = '--';

class PlaceOrderOption extends Component {
  constructor(props) {
    super(props);
    props.innerRef(this);
    this.state = {
      orderType: props.orderType ? props.orderType : props.orderTypes.length > 0 ? props.orderTypes[0].value : '',
      priceMinusStep: {
        'tableCode': '01',
        'fromPrice': 0.001,
        'toPrice': 0.25,
        'spread': 0.001
      },
      pricePlusStep: {
        'tableCode': '01',
        'fromPrice': 0.001,
        'toPrice': 0.25,
        'spread': 0.001
      },
      stopPriceMinusStep: {
        'tableCode': '01',
        'fromPrice': 0.001,
        'toPrice': 0.25,
        'spread': 0.001
      },
      stopPricePlusStep: {
        'tableCode': '01',
        'fromPrice': 0.001,
        'toPrice': 0.25,
        'spread': 0.001
      },
      newGoodTillDates: [{ value: DESELECT_OPTION, label: DESELECT_OPTION }, ...props.goodTillDates],
      grossAmount: '-',
      priceSelectList : false,
      quantitySelectList : false,
      selectPriceListData : [`${this.props.language.follow_price}`,`${this.props.language.follow_bid1}`,`${this.props.language.follow_ask1}`],
      avaiableBuyQuantity:'-',
      avaiableQuantity : '-',
      selectQuatitybuyListData :[
        {
          label: `${this.props.language.available_for_buy}`,
          value : '-',
          proportion:'',
          id:'1'
        },
        {
          label: `${this.props.language.common_buy}`,
          value : '-',
          proportion:'3/4',
          id:'2'
        },
        {
          label: `${this.props.language.common_buy}`,
          value : '-',
          proportion:'1/2',
          id:'3'
        },
        {
          label:  `${this.props.language.common_buy}`,
          value : '-',
          proportion:'1/4',
          id:'4'
        }
      ],
      selectQuatitysellListData :[
        {
          label: `${this.props.language.available_for_sell}`,
          value : '-',
          proportion:'',
          id:'1'
        },
        {
          label: `${this.props.language.common_sell}`,
          value : '-',
          proportion:'3/4',
          id:'2'
        },
        {
          label: `${this.props.language.common_sell}`,
          value : '-',
          proportion:'1/2',
          id:'3'
        },
        {
          label: `${this.props.language.common_sell}`,
          value : '-',
          proportion:'1/4',
          id:'4'
        }
      ],
      datepicker:false,
      InputLabel:'common_quantity',
      InputLabelPrice:'common_price',
    }
  }

  render() {
    const { 
      language, 
      tradeInformation, 
      lotSize, 
      orderTypes, 
      isModifyOrder, 
      showGrossAmount, 
      showGrossAmountBorder , 
      currencyID , 
      cashAccountData , 
      buyingPower,
    } = this.props;
    const {
      priceMinusStep,
      pricePlusStep,
      newGoodTillDates,
      orderType,
      stopPriceMinusStep,
      stopPricePlusStep,
      grossAmount,
      priceSelectList,
      quantitySelectList,
      selectPriceListData,
      avaiableBuyQuantity,
      avaiableQuantity,
      selectQuatitybuyListData,
      selectQuatitysellListData,
      datepicker,
      InputLabelPrice,
      InputLabel
    } = this.state;
    const usePrePost = iTradeEnv?.pages?.trade?.usePrePost
    return (
      <div className="place-order-option-container">
        {!isModifyOrder && <div className="option-item">
          <label>{language.common_order_type}</label>
          <div className="input">
            <Dropdown
              textCenter
              style={{ height: '30px', width: '100%', textAlign: 'left' }}
              selectedOptions={[this.hasOption(orderTypes, orderType, orderTypes[0])]}
              options={orderTypes}
              innerRef={e => this.orderTypeRef = e}
              onChange={this.handleChangeOrderType}
            />
          </div>
        </div>}
        {!isModifyOrder && orderType === ORDER_TYPE.TRIGGER_ORDER.value &&
          <div className="option-item">
            <label>{language.common_stop_price}</label>
            <div className="input stop-price-input">
              <Dropdown
                textCenter
                style={{ height: '30px' }}
                selectedOptions={[STOP_TYPE_TYPE[0]]}
                options={STOP_TYPE_TYPE}
                innerRef={e => this.stopTypeDirectionRef = e}
              />
              <Input style={{ height: '30px', flexGrow: '1' }}
                innerRef={e => this.stopPriceRef = e}
                priceMode={true}
                minusStep={stopPriceMinusStep.spread}
                plusStep={stopPricePlusStep.spread}
                onChange={(price) => this.handleChangePrice(price, true)}
                // prevKey={INDEX_KEY.PRICE}
                currentKey={INDEX_KEY.STOP_PRICE}
                // nextKey={INDEX_KEY.GTD}
                onKeyPress={this.keySequence}
              />
            </div>
          </div>}
        {utilsFunction.isOrderNeedEnterPrice(orderType) && <div className="option-item">
          {isModifyOrder
            ? <label for={InputLabelPrice}>{language.order_new_properties.format(language.common_price)}</label>
            : <label for={InputLabelPrice}>{language.common_price}</label>
          }
          <div className="input">
            <Input style={{ width: '100%', height: '30px' }}
              id={InputLabelPrice}
              innerRef={e => this.priceRef = e}
              priceMode={true}
              minusStep={priceMinusStep.spread}
              plusStep={pricePlusStep.spread}
              onChange={this.handleChangePrice}
              prevKey={INDEX_KEY.ORDER_TYPE}
              currentKey={INDEX_KEY.PRICE}
              nextKey={INDEX_KEY.QTY}
              onKeyPress={this.keySequence} />
              <span className='pirce-icon' title="pirce-icon" onClick={(e)=>{
              this.setState({priceSelectList : !priceSelectList , quantitySelectList : false});
              e.nativeEvent.stopImmediatePropagation()}} ></span>
              {priceSelectList && <div className='price-list'>
                {
                  selectPriceListData.map((item, index)=>
                  <div key={index} className='price-selct-item' onClick={()=>this.selectPrice(index)}>
                    <span >{item}</span>
                  </div>
                  )
                }
                  
                  {/* <div className='price-selct-item' onClick={()=>this.selectPrice(event)}>
                    <span>{language.follow_bid1}</span>
                  </div>
                  <div className='price-selct-item' onClick={()=>this.selectPrice(event)}>
                    <span>{language.follow_ask1}</span>
                  </div> */}
              </div>}
          </div>
        </div>}
        <div className="option-item">
          {isModifyOrder
            ? <label for={InputLabel}>{language.order_new_properties.format(language.common_quantity)}</label>
            : <label for={InputLabel}>{language.common_quantity}</label>
          }
          <div className="input">
            <Input style={{ width: '100%', height: '30px' }}
              id={InputLabel}
              innerRef={e => this.quantityRef = e}
              step={lotSize}
              onChange={this.handleChangeQuantity}
              prevKey={INDEX_KEY.PRICE}
              currentKey={INDEX_KEY.QTY}
              nextKey={INDEX_KEY.GTD}
              onKeyPress={this.keySequence}
              dataType={dataType.NUMBER} />
              <span className='quantity-icon' onClick={(e)=>{
              this.setState({quantitySelectList : !quantitySelectList , priceSelectList:false})
              e.nativeEvent.stopImmediatePropagation()
              }}></span>
              {quantitySelectList && <div className='quantity-list'>
                  <div className='quantity-selct-buy-item' >
                  {selectQuatitybuyListData.map((item,index)=>
                   <span className={classnames('item' , 'buy-item')} onClick={()=>this.selectQuantity(item)} key={index}>
                      {item.label} {item.proportion}
                      <span className='price' >{formatFunctions.dataFormat(item.value , dataType.NUMBER)}</span> 
                    </span>)}
                  </div>
                  <div className='quantity-selct-sell-item'>
                    {selectQuatitysellListData.map((item,index)=>
                    <span className={classnames('item' , 'sell-item')} onClick={()=>this.selectQuantity(item)} key={index}>
                      {item.label} {item.proportion}
                      <span className='price'>{formatFunctions.dataFormat(item.value , dataType.NUMBER)}</span> 
                    </span>)}
                  </div>
              </div>}
          </div>
        </div>
        {!isModifyOrder && <div className="option-item">
          <label for="commonGoodTillDate">{language.common_good_till_date}</label>
          <div className="input">
            <input className='datepicker' defaultValue={"-"} 
            id="commonGoodTillDate"
            ref={e => this.goodTillDateRef = e }  
            onFocus={()=>{this.setState({datepicker : true})}}
            onBlur={()=> {this.setState({datepicker : false})}}
            readOnly
            >
            </input>
            <span className={classnames('date-icon' )}
             onClick={this.setDatepicker}
             onMouseDown={(e)=>{e.preventDefault()}}
            ></span>
            {datepicker && <DatePicker   
              setGoodTillDate={this.setGoodTillDate}
              data = {this.props.goodTillDates}
              defaultValue = {this.goodTillDateRef.value=="-"?this.props.goodTillDates[0].value:this.goodTillDateRef.value}
            />} 
          </div>
          
        </div>}
        {/* {!isModifyOrder && <div className="option-item">
          <label>{language.common_good_till_date}</label>
          <div className="input">
            <Dropdown
              textCenter
              style={{ height: '30px', width: '100%', textAlign: 'left' }}
              selectedOptions={[newGoodTillDates[0]]}
              options={newGoodTillDates}
              innerRef={e => this.goodTillDateRef = e}
            />
          </div>
        </div>} */}
        {usePrePost && <div className="option-item" style={{height:'30px'}}>
          <label onClick={() => {usePrePost && openPrePostDialog()}} className="description_label">
            {language.common_order_statement}
            <img src={descriptionIcon}/>
          </label>
        </div>}
        {<div className={classnames("available-buy-sell")}>
          <div className = 'available-buy'>
            <label>{language.available_for_buy}</label>
            <span>{formatFunctions.dataFormat(avaiableBuyQuantity, dataType.NUMBER)}</span>
          </div>
          <div className = 'available-sell'>
            <label>{language.available_for_sell}</label>
            <span>{formatFunctions.dataFormat(avaiableQuantity, dataType.NUMBER)}</span>
          </div>
        </div>}
        <div className="asset-index">
          {/* <div className="asset-item">
            <label>{language.common_buying_power}</label>
            <label className="value">
              <span>{currencyID}</span>
              <span>{formatFunctions.dataFormat(buyingPower, dataType.CASH)}</span>
            </label>
          </div> */}
          <div className="asset-item">
            <label>{language.place_order_dialog_gross_amount}</label>
            <label className="value">
              <span>{currencyID}</span>
              <span>{grossAmount}</span>
            </label>
          </div>
        </div>
      </div>
    )
  }

  hasOption = (options, value, defaultOption) => {
    const hasItem = options.find(v => v.value === value)
    if (hasItem) return hasItem
    return defaultOption
  }

  computeGrossAmount = (price, quantity) => {
    const { currencyID } = this.props;
    const grossAmount = formatFunctions.dataFormat(price * quantity, dataType.CASH);
    // const grossAmountText = `${grossAmount > 0 ? currencyID : ''} ${grossAmount}`
    this.setState({ grossAmount: grossAmount })
  }

  handleChangeOrderType = (orderType) => {
    if (orderType.length > 0) {
      this.setState({
        orderType: orderType[0].value 
      })
      if(orderType[0].value === ORDER_TYPE.AT_AUCTION.value ){
        this.setState({
          grossAmount:'-'
        })
      }
      this.props.handleAllowBuy(orderType);
    }
  }

  handleChangeQuantity = (quantity) => {
    let changeData;
    if(utilsFunction.isOrderNeedEnterPrice(this.state.orderType)){
      changeData = {
        price: this.priceRef.getValue(),
        quantity,
      }
    }else{
      changeData = {
        price: '',
        quantity,
      }
    }
    if (this.state.orderType === ORDER_TYPE.TRIGGER_ORDER) {
      changeData.stopPrice = this.stopPriceRef.getValue()
    }
    this.props.onChange(changeData);
    if(utilsFunction.isOrderNeedEnterPrice(this.state.orderType)){
      this.computeGrossAmount(changeData.price, changeData.quantity);
    }
  }

  handleChangePrice = (price, isStopPrice = false) => {
    const priceNumber = parseFloat(price);
    if (!isNaN(priceNumber)) {
      const { priceMinusStep, pricePlusStep, stopPriceMinusStep, stopPricePlusStep } = this.state;
      const minusStep = isStopPrice ? stopPriceMinusStep : priceMinusStep;
      const plusStep = isStopPrice ? stopPricePlusStep : pricePlusStep;
      if (minusStep.fromPrice === plusStep.fromPrice) {
        if (priceNumber <= minusStep.fromPrice || priceNumber >= minusStep.toPrice) {
          this.determinePriceStep(priceNumber, isStopPrice);
        }
      } else {
        this.determinePriceStep(priceNumber, isStopPrice);
      }
      const changeData = {
        price: isStopPrice ? this.priceRef.getValue() : priceNumber,
        quantity: this.quantityRef.getValue(),
      }
      if (this.state.orderType === ORDER_TYPE.TRIGGER_ORDER) {
        changeData.stopPrice = isStopPrice ? priceNumber : this.stopPriceRef.getValue()
      }
      this.props.onChange(changeData);
      this.computeGrossAmount(changeData.price, changeData.quantity);
    }
  }

  determinePriceStep(price, isStopPrice = false) {
    const { spreadTable } = this.props;
    if (price) {
      for (let i = 0; i < spreadTable.length; i++) {
        const tmp = spreadTable[i];
        if (price < tmp.fromPrice || (price > tmp.fromPrice && price < tmp.toPrice)) {
          isStopPrice
            ? this.setState({ stopPriceMinusStep: tmp, stopPricePlusStep: tmp })
            : this.setState({ priceMinusStep: tmp, pricePlusStep: tmp })
          break;
        } else if (price === tmp.fromPrice) {
          const minusStep = i === 0 ? tmp : spreadTable[i - 1];
          isStopPrice
            ? this.setState({ stopPriceMinusStep: minusStep, stopPricePlusStep: tmp })
            : this.setState({ priceMinusStep: minusStep, pricePlusStep: tmp })
          break;
        } else if (price === tmp.toPrice && i < spreadTable.length - 1) {
          isStopPrice
            ? this.setState({ stopPriceMinusStep: tmp, stopPricePlusStep: spreadTable[i + 1] })
            : this.setState({ priceMinusStep: tmp, pricePlusStep: spreadTable[i + 1] })
          break;
        }
        if (i === spreadTable.length - 1) {
          isStopPrice
            ? this.setState({ stopPriceMinusStep: tmp, stopPricePlusStep: tmp })
            : this.setState({ priceMinusStep: tmp, pricePlusStep: tmp })
          break;
        }
      }
    } else {
      const tmp = spreadTable[0] || this.state.priceMinusStep;
      
      isStopPrice
        ? this.setState({ stopPriceMinusStep: tmp, stopPricePlusStep: tmp })
        : this.setState({ priceMinusStep: tmp, pricePlusStep: tmp })
    }
  }

  focusPrice = () => {
    this.priceRef.focusInput();
  }

  setQuantity = (qty) => {
    this.quantityRef.setValue(qty);
    if(utilsFunction.isOrderNeedEnterPrice(this.state.orderType)){
      const price = this.priceRef.getValue();
      this.computeGrossAmount(price, qty);
    }
  }

  setPrice = (price) => {
    if(utilsFunction.isOrderNeedEnterPrice(this.state.orderType)){
      this.priceRef.setValue(price);
      const quantity = this.quantityRef.getValue();
      this.computeGrossAmount(price, quantity);
    }
  }

  setGoodTillDate = (date) => {
    if (date) {
      this.goodTillDateRef.blur();
      this.goodTillDateRef.value=date;
      this.setState({datepicker :false})
    }
  }

  setOrderType = (type, orderData) => {
    if (type) {
      this.orderTypeRef.setValue([type]);
      this.setState({ orderType: type.value }, () => {
        if (type.value === ORDER_TYPE.TRIGGER_ORDER.value) {
          this.stopTypeDirectionRef.setValue([orderData.stopType]);
          this.stopPriceRef.setValue(orderData.stopPrice);
        }
      })
    }
  }

  reset = () => {
    this.setOrderType(this.props.orderTypes[0])
    this.setPrice(formatFunctions.dataFormat(0, dataType.CURRENCY));
    this.setQuantity(formatFunctions.dataFormat(0, dataType.NUMBER));
    // this.setGoodTillDate(this.props.forum_today);
    this.setGoodTillDate('-');
  }

  validateInput = () => {
    this.priceRef.formatNumber(this.priceRef.getValue());
    this.quantityRef.formatNumber(this.quantityRef.getValue());
    if (this.state.orderType === ORDER_TYPE.TRIGGER_ORDER.value) {
      this.stopPriceRef.formatNumber(this.stopPriceRef.getValue())
    }
  }

  getOptions = () => {
    let orderType = JSON.parse(JSON.stringify(this.state.orderType));
    let goodTillDate = '';
    if (!this.props.isModifyOrder) {
      orderType = this.orderTypeRef.getValue()[0];
        const goodTillDateArray = this.goodTillDateRef;
        if (goodTillDateArray.value === '-') {
          goodTillDate = {value:''}
          // if (goodTillDate.value === DESELECT_OPTION) {
          //   goodTillDate = '';
          // }
        }else{
          goodTillDate = goodTillDateArray
        }
    }
    // let orderType = JSON.parse(JSON.stringify(this.state.orderType));
    // let goodTillDate = '';
    // if (!this.props.isModifyOrder) {
    //   orderType = this.orderTypeRef.getValue()[0];
    //   const goodTillDateArray = this.goodTillDateRef.getValue();
    //   if (goodTillDateArray.length > 0) {
    //     goodTillDate = goodTillDateArray[0]
    //     if (goodTillDate.value === DESELECT_OPTION) {
    //       goodTillDate = '';
    //     }
    //   }
    // }
    const quantity = this.quantityRef.getValue();
    let stopType = null;
    let stopPrice = null;
    if (!this.props.isModifyOrder && this.state.orderType === ORDER_TYPE.TRIGGER_ORDER.value) {
      stopType = this.stopTypeDirectionRef.getValue()[0];
      stopPrice = this.stopPriceRef.getValue();
    }
    if(utilsFunction.isOrderNeedEnterPrice(orderType)){
      const price = this.priceRef.getValue();
      return {
        orderType,
        price,
        quantity,
        goodTillDate,
        stopType,
        stopPrice,
      }
    }
    return {
      orderType,
      quantity,
      goodTillDate,
      stopType,
      stopPrice,
    }
  }

  keySequence = (data) => {
    switch (data.currentKey) {
      case INDEX_KEY.PRICE:
        if (this.priceRef.getValue() === '0' || this.priceRef.getValue() === "") {
          return;
        }
        this.quantityRef.inputRef.focus();
        break;
      case INDEX_KEY.QTY:
        if (this.quantityRef.getValue() === '0' || this.quantityRef.getValue() === "") {
          return;
        }
        this.quantityRef.inputRef.blur();
        this.goodTillDateRef.focus();
        break;
      case INDEX_KEY.STOP_PRICE:
        if (this.stopPriceRef.getValue() === '0' ||　this.stopPriceRef.getValue() === "") {
          return;
        }
        this.priceRef.inputRef.focus();
        break;
      default:
        break;
    }
  }

  updatePriceStepInit = () => {
    const { spreadTable } = this.props;
    if (spreadTable && spreadTable.length > 0) {
      this.setState({
        priceMinusStep: spreadTable[0],
        pricePlusStep: spreadTable[0],
        stopPriceMinusStep: spreadTable[0],
        stopPricePlusStep: spreadTable[0]
      })
    }
  }

  setSelectQuantity = () => {
    const { avaiableBuyQuantity, avaiableQuantity } = this.props
    if(avaiableBuyQuantity){
      this.setState({
        avaiableBuyQuantity:avaiableBuyQuantity,
        selectQuatitybuyListData: [
          {
            label: `${this.props.language.available_for_buy}`,
            value : avaiableBuyQuantity,
            id:'1'
          },
          {
            label: `${this.props.language.common_buy} 3/4`,
            value : 3*(avaiableBuyQuantity /4),
            id:'2'
          },
          {
            label: `${this.props.language.common_buy} 1/2`,
            value : avaiableBuyQuantity /2,
            id:'3'
          },
          {
            label: `${this.props.language.common_buy} 1/4`,
            value : avaiableBuyQuantity /4,
            id:'4'
          },
        ]
      })
    }else{
      this.setState({
        avaiableBuyQuantity : '-',
        selectQuatitybuyListData: [
          {
            label: `${this.props.language.available_for_buy}`,
            value : '0',
            id:'1'
          },
          {
            label: `${this.props.language.common_buy} 3/4`,
            value : '0',
            id:'2'
          },
          {
            label: `${this.props.language.common_buy} 1/2`,
            value : '0',
            id:'3'
          },
          {
            label: `${this.props.language.common_buy} 1/4`,
            value : '0',
            id:'4'
          },
        ]
      })
    }
    if(avaiableQuantity){
      this.setState({
        avaiableQuantity:avaiableQuantity,
        selectQuatitysellListData: [
          {
            label: `${this.props.language.available_for_sell}`,
            value : avaiableQuantity,
            id:'1'
          },
          {
            label: `${this.props.language.common_sell} 3/4`,
            value : 3*(avaiableQuantity /4),
            id:'2'
          },
          {
            label: `${this.props.language.common_sell} 1/2`,
            value : avaiableQuantity /2,
            id:'3'
          },{
            label: `${this.props.language.common_sell} 1/4`,
            value : avaiableQuantity /4,
            id:'4'
          },
        ]
      })
    }else{
      this.setState({
        avaiableQuantity : '-',
        selectQuatitysellListData: [
          {
            label: `${this.props.language.available_for_sell}`,
            value : '0',
            id:'1'
          },
          {
            label: `${this.props.language.common_sell} 3/4`,
            value : '0',
            id:'2'
          },
          {
            label: `${this.props.language.common_sell} 1/2`,
            value : '0',
            id:'3'
          },{
            label: `${this.props.language.common_sell} 1/4`,
            value : '0',
            id:'4'
          },
        ]
      })
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.spreadTable !== this.props.spreadTable) {
      this.updatePriceStepInit();
    }
    if (prevProps.goodTillDates !== this.props.goodTillDates) {
      this.setState({
        newGoodTillDates: [{ value: DESELECT_OPTION, label: DESELECT_OPTION }, ...this.props.goodTillDates]
      })
    }
    if(prevProps.orderTypes !== this.props.orderTypes){
      // setTimeout(() => {
      //   this.setState({
      //     orderType:this.props.orderTypes[0]
      //   })
      // }, 200)
    }
    if(prevProps.cashAccountData !== this.props.cashAccountData  || this.props.currentMarket && prevProps.currentMarket !== this.props.currentMarket){
      this.setSelectQuantity()
    }
    if(prevProps.avaiableQuantity !== this.props.avaiableQuantity){
      this.setSelectQuantity()
    }
    if(this.props.language != prevProps.language){
      this.setSelectQuantity()
      let selectPriceList =  [`${this.props.language.follow_price}`,`${this.props.language.follow_bid1}`,`${this.props.language.follow_ask1}`]
      this.setState({
        selectPriceListData :selectPriceList
      })
    }
  }
  hiddenList=()=>{
    this.setState({
      priceSelectList : false,
      quantitySelectList :false,
      // datepicker : false
    })
  }
  componentDidMount() {
    this.updatePriceStepInit();
    document.addEventListener('click' , this.hiddenList)
  }

  componentWillUnmount = () =>{
    this.setState = (state,callback)=>{
      return
    }
    document.removeEventListener('click' , this.hiddenList)
  }

  selectPrice=(index)=>{
    let changeData;
    switch (index) {
      case 0:
        this.priceRef.setValue(this.props.quoteData.last);
        changeData = {
          price: this.props.quoteData.last ,
          quantity: this.quantityRef.getValue(),
        }
        this.handleChangePrice(changeData.price);
        break;
      case 1:
        this.priceRef.setValue(this.props.biddata[0]?.price || '0');
        changeData = {
          price: this.props.biddata[0]?.price || '0' ,
          quantity: this.quantityRef.getValue(),
        }
        this.handleChangePrice(changeData.price);
        break;
      case 2:
        this.priceRef.setValue(this.props.askdata[0]?.price || '0');
        changeData = {
          price: this.props.askdata[0]?.price || '0',
          quantity: this.quantityRef.getValue(),
        }
        this.handleChangePrice(changeData.price);
        break;

      default:
        break;
    }
    this.setState({quantitySelectList : false ,priceSelectList:false})
    
  }

  selectQuantity=(item)=>{
    this.quantityRef.setValue(item.value);
    const changeData = {
      price: this.priceRef.getValue() ,
      quantity: item.value,
    }
    this.handleChangeQuantity(changeData.quantity);
    // this.computeGrossAmount(changeData.price, changeData.quantity);
    this.setState({quantitySelectList : false ,priceSelectList:false})
  }


  setDatepicker=()=>{
    const {datepicker , orderType} = this.state
    if(!datepicker){
      this.goodTillDateRef.focus();
      this.setState({datepicker : true})
    }else{
      this.goodTillDateRef.blur();
      this.setState({datepicker : false})
    }
  }
}

PlaceOrderOption.defaultProps = {
  innerRef: () => {
  },
  tradeInformation: null,
  spreadTable: [],
  lotSize: 1,
  isModifyOrder: false,
  onChange: () => {
  },
  openGTDByTab: null,
  showGrossAmount: null,
  showGrossAmountBorder: false,
  currencyID: 'HKD'
}

export default connect(
  state => ({
    language: state.app.language,
    goodTillDates: state.trade.goodTillDates,
    orderTypes: state.trade.orderTypes,
    cashAccountData : state.trade.cashAccountData,
    currentMarket: state.trade.currentMarket,
  })
)(PlaceOrderOption)
